import { useQuery, useQueryClient } from "react-query";
import { UserHttpService } from "../service";

/**
 * A custom React hook for fetching and paginating explore posts.
 * @returns {{
 *   data: any,
 *   isLoading: boolean,
 *   isError: boolean,
 * }}
 */
function UseUserList() {
    const queryClient = useQueryClient();

    const {
        data,
        isLoading,
        isError,
        refetch,
    } = useQuery(
        ["user_list"],
        () => {
            return UserHttpService.loadUsers()
        },
        {
            onSuccess: (data) => {
                // console.log(data);
            }
        }
    );

    const removeItemFromList = (jobId) => {
        queryClient.setQueryData(["user_list"], oldData => ({
            ...oldData,
            results: oldData.results.filter(job => job.id !== jobId)
        }));
    };

    return { data, isLoading, isError, removeItemFromList, refetch };
}

export default UseUserList;